import { z } from 'zod';
import { Contact, TextItem } from './common';
export var EnvironmentSafetyStep = TextItem;
export var SupportContact = Contact;
export var EnvironmentSafety = z.object({
    /**
     * A list of removal steps
     */ removalSteps: z.array(EnvironmentSafetyStep).prefault([]),
    /**
     * A list of environment safety support contacts
     */ supportContacts: z.array(SupportContact).prefault([])
}).prefault({
    removalSteps: [],
    supportContacts: []
});
